<template>
  <div>
    <div class="form-section">
      <h3>Nạp thẻ nhận quà <br> TQC Tần Tử Anh</h3>
      <div class="login-inner-form">
        <form action="https://checkout.zpay.pro/create" method="POST" target="_blank" id="paymentForm">
          <input type="hidden" name="currency" value="VND">
          <input type="hidden" name="p_key" value="p_d7061ec4226bd9a356fcd62598226c90">
          <input type="hidden" name="country" value="VN">
          <input type="hidden" name="redirect_url" value="https://pro.3kprivate.com/thong-tin-tai-khoan">
          <input type="hidden" name="cancel_url" value="https://pro.3kprivate.com/nap-the">

          <input type="hidden" name="ref_id" :value="`${user.account}_${Math.floor(Date.now() / 1000)}`">

          <div class="black left">Tài khoản</div>
          <div class="form-group form-box">
            <input type="text" id="account" name="account" class="input-text" readonly="readonly" v-model="user.account">
            <i class="flaticon-user"></i>
          </div>
          <div class="black left">Phương thức thanh toán</div>
          <div class="form-group form-box">
            <input type="text" id="method" name="method" class="input-text" readonly="readonly" value="PayGate">
          </div>
          <div class="form-group form-box">
            <b style="color: red;">
              Bạn đang tiến hành hiến máu cho máy chủ Tần Tử Anh
              <br/>
              Kim Nguyên Bảo và quà tặng sẽ được gửi qua Thương Thành
              <br/>
              <br/>
              Vui lòng liên hệ GM Bruce Lee để được hỗ trợ!
            </b>
          </div>
          <div class="form-group mb-0">
            <button type="button" @click="processCharge" class="btn-md btn-theme btn-block">Hiến Máu</button>
          </div>
        </form>
      </div>
    </div>

    
  </div>
</template>

<script>
  // import axios from 'axios';  
  // import Menu from './Menu'

  export default {
    name: 'Charge',
    components: {
      // Menu
    },
    props: {
      tqc_api: String,
      token: String,
      user: {}
    },
    mounted() {
      this.$emit('get-info')
    },
    methods: {
      processCharge() {
        if (this.clicked) {
          return false
        }
        /* if (!this.validate()) {
          return false
        }

        if (!confirm('Bạn chắc chắn đã chọn đúng thẻ và mệnh giá?')) {
          return false
        } */

        this.clicked = true

        document.getElementById('paymentForm').submit()

        this.clicked = false

        /* axios.post(`${this.tqc_api}process-card`, {
            token: this.token,
            card_type: this.card_type,
            amount: this.amount,
            pin_number: this.pin_number,
            serial: this.serial,
          }).then(({
            data
          }) => {
            if (data.status == 99) {
              alert('Hệ thống đang xử lý, vui lòng chờ giây lát!');
              this.serial = ''
              this.pin_number = ''
            } else {
              alert(data.message)
            }
            this.clicked = false
          }).catch(error => {
            this.clicked = false
            alert('Thông tin không chính xác !')
          }) */
      },
      validate() {
        if (this.pin_number.length < 6) {
          alert('Mã Pin không được để trống !')
          return false
        }

        if (this.serial.length < 6) {
          alert('Số serial không được để trống !')
          return false
        }

        return true
      }
    },
    data() {
      return {
        pin_number: '',
        serial: '',
        card_type: 'VIETTEL',
        amount: '10000',
        clicked: false
      }
    }
  }
</script>

<style scoped>
.black {
  color: black;
}
.left {
  text-align: left;
}
</style>